/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SyncStatusWithRetry } from './syncStatusWithRetry';


/**
 * Data payload for \'appointment.sync_failed\' notifications.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentSyncFailedData { 
    appointmentId: number;
    isSyncing: boolean;
    success: boolean;
    failedSteps: Array<string>;
    syncStatus: SyncStatusWithRetry;
}
export const AppointmentSyncFailedData_appointmentId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncFailedData_isSyncing_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncFailedData_success_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncFailedData_failedSteps_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncFailedData_syncStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];


